import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AsyncPipe, NgIf, NgStyle } from '@angular/common';
import { Component, inject, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Observable, map, shareReplay } from 'rxjs';

@Component({
  selector: 'app-ai-agent-configuration-get-started',
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    NgIf,
    NgStyle,
    AsyncPipe,
    MatProgressSpinnerModule
  ],
  templateUrl: './ai-agent-configuration-get-started.component.html',
  styleUrl: './ai-agent-configuration-get-started.component.scss'
})
export class AiAgentConfigurationGetStartedComponent {
  onInboundClickEvent = output<any>();
  onOutboundClickEvent = output<any>();
  loading = false;
  private breakpointObserver = inject(BreakpointObserver);

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );


  onInboundClick() {
    this.loading = true;
    this.onInboundClickEvent.emit(null);
  }

  onOutboundClick() {
    this.loading = true;
    this.onOutboundClickEvent.emit(null)
  }
}
